import React from 'react';

import { ReactComponent as CommunicationLogs } from './CommunicationLogs.svg';
import { ReactComponent as Pipelines } from './Pipelines.svg';
import { ReactComponent as Reports } from './Reports.svg';
import { ReactComponent as Inbox } from './Inbox.svg';
import { ReactComponent as Conversations } from './Conversations.svg';
import { ReactComponent as Todos } from './Todos.svg';
import { ReactComponent as Email } from './Email.svg';
import { ReactComponent as EmailOpened } from './EmailOpened.svg';
import { ReactComponent as Link } from './Link.svg';
import { ReactComponent as Message } from './Message.svg';
import { ReactComponent as Milestone } from './Milestone.svg';
import { ReactComponent as PhoneCall } from './PhoneCall.svg';
import { ReactComponent as Search } from './Search.svg';
import { ReactComponent as WebForm } from './WebForm.svg';
import { ReactComponent as Business } from './Business.svg';
import { ReactComponent as Clock } from './Clock.svg';
import { ReactComponent as Lightning } from './Lightning.svg';
import { ReactComponent as Bolt } from './Bolt.svg';
import { ReactComponent as Filters } from './Filters.svg';
import { ReactComponent as Hourglass } from './Hourglass.svg';
import { ReactComponent as Notes } from './Notes.svg';
import { ReactComponent as Person } from './Person.svg';
import { ReactComponent as PersonSearch } from './PersonSearch.svg';
import { ReactComponent as LeftArrow } from './LeftArrow.svg';
import { ReactComponent as RightArrow } from './RightArrow.svg';
import { ReactComponent as Settings } from './Settings.svg';
import { ReactComponent as Rotate } from './Rotate.svg';
import { ReactComponent as Won } from './Won.svg';
import { ReactComponent as Archive } from './Archive.svg';
import { ReactComponent as Lost } from './Lost.svg';
import { ReactComponent as Templates } from './Templates.svg';
import { ReactComponent as User } from './User.svg';
import { ReactComponent as TodoSchedule } from './TodoSchedule.svg';
import { ReactComponent as Calendar } from './Calendar.svg';
import { ReactComponent as Services } from './Services.svg';
import { ReactComponent as TodoAlert } from './TodoAlert.svg';
import { ReactComponent as TodoComplete } from './TodoComplete.svg';
import { ReactComponent as TodoConsultation } from './TodoConsultation.svg';
import { ReactComponent as TodoFollowUp } from './TodoFollowUp.svg';
import { ReactComponent as TodoOther } from './TodoOther.svg';
import { ReactComponent as TodoInPersonMeeting } from './TodoInPersonMeeting.svg';
import { ReactComponent as Plus } from './Plus.svg';
import { ReactComponent as Close } from './Close.svg';
import { ReactComponent as X } from './X.svg';
import { ReactComponent as Eye } from './Eye.svg';
import { ReactComponent as Lock } from './Lock.svg';
import { ReactComponent as Logout } from './Logout.svg';
import { ReactComponent as Add } from './Add.svg';
import { ReactComponent as Marketing } from './Marketing.svg';
import { ReactComponent as MarketingSource } from './MarketingSource.svg';
import { ReactComponent as MarketingMedium } from './MarketingMedium.svg';
import { ReactComponent as MarketingCampaign } from './MarketingCampaign.svg';
import { ReactComponent as MarketingContent } from './MarketingContent.svg';
import { ReactComponent as MarketingKeyword } from './MarketingKeyword.svg';
import { ReactComponent as Trash } from './Trash.svg';
import { ReactComponent as Signature } from './Signature.svg';
import { ReactComponent as BasicStar } from 'images/svg/BasicStar.svg';
import { ReactComponent as Social } from 'images/svg/Social.svg';
import { ReactComponent as GripVertical } from 'images/svg/GripVertical.svg';
import { ReactComponent as Help } from 'images/svg/Help.svg';
import { ReactComponent as Money } from 'images/svg/Money.svg';
import { ReactComponent as At } from 'images/svg/At.svg';
import { ReactComponent as SocialAlt } from 'images/svg/SocialAlt.svg';
import { ReactComponent as Target } from 'images/svg/Target.svg';
import { ReactComponent as Respond } from 'images/svg/Respond.svg';
import { ReactComponent as MoveStage } from 'images/svg/MoveStage.svg';
import { ReactComponent as Print } from 'images/svg/Print.svg';
import { ReactComponent as Billboard } from 'images/svg/Billboard.svg';
import { ReactComponent as Radio } from 'images/svg/Radio.svg';

import { ReactComponent as BoundSelectArrow } from './BoundSelectArrow.svg';
import { ReactComponent as FacebookOnboard1 } from './FacebookOnboard1.svg';
import { ReactComponent as FacebookOnboard2 } from './FacebookOnboard2.svg';
import { ReactComponent as FacebookOnboard3 } from './FacebookOnboard3.svg';

import { svgImages } from '../index.js';

export const iconMap = {
  Email: Email,
  EmailOpened: EmailOpened,
  Link: Link,
  Message: Message,
  Milestone: Milestone,
  PhoneCall: PhoneCall,
  Search: Search,
  WebForm: WebForm,
  CommunicationLogs: CommunicationLogs,
  Pipelines: Pipelines,
  Reports: Reports,
  Inbox: Inbox,
  Conversations: Conversations,
  Todos: Todos,
  TodoSchedule: TodoSchedule,
  Business: Business,
  Clock: Clock,
  Lightning: Lightning,
  Bolt: Bolt,
  Filters: Filters,
  Hourglass: Hourglass,
  Notes: Notes,
  Person: Person,
  PersonSearch: PersonSearch,
  LeftArrow: LeftArrow,
  RightArrow: RightArrow,
  Settings: Settings,
  Rotate: Rotate,
  Won: Won,
  Archive: Archive,
  Lost: Lost,
  Templates: Templates,
  User: User,
  Calendar: Calendar,
  Services: Services,
  TodoAlert: TodoAlert,
  TodoComplete: TodoComplete,
  TodoConsultation: TodoConsultation,
  TodoFollowUp: TodoFollowUp,
  TodoOther: TodoOther,
  TodoInPersonMeeting: TodoInPersonMeeting,
  Plus: Plus,
  Close: Close,
  X: X,
  Eye: Eye,
  Lock: Lock,
  Add: Add,
  Logout: Logout,
  Marketing: Marketing,
  MarketingSource: MarketingSource,
  MarketingMedium: MarketingMedium,
  MarketingCampaign: MarketingCampaign,
  MarketingContent: MarketingContent,
  MarketingKeyword: MarketingKeyword,
  Trash: Trash,
  Signature: Signature,
  BasicStar: BasicStar,
  Social: Social,
  Money: Money,
  At: At,
  SocialAlt: SocialAlt,
  Target: Target,
  BoundSelectArrow: BoundSelectArrow,
  FacebookOnboard1: FacebookOnboard1,
  FacebookOnboard2: FacebookOnboard2,
  FacebookOnboard3: FacebookOnboard3,
  GripVertical: GripVertical,
  Respond: Respond,
  MoveStage: MoveStage,
  Print: Print,
  Billboard: Billboard,
  Radio: Radio,
  Help: Help,
};

const SVG = React.memo(({ icon, basic = false, type = 'svg', invert = false, className, title, onClick = () => {} }) => {
  const Icon = iconMap[icon];

  if (!Icon) {
    return (
      <div className={'svg-wrapper'} data-title={title}>
        <img className={className} src={icon} alt={'SVG'} />
      </div>
    );
  }

  if (type === 'image') {
    return (
      <div className={'svg-wrapper'} data-title={title}>
        <img src={svgImages[icon]} alt={'SVG'} />
      </div>
    );
  }

  return (
    <div className={`svg-wrapper ${className || ''} ${basic ? 'basic' : ''} ${invert ? 'invert' : ''}`} onClick={onClick} data-title={title}>
      <Icon />
    </div>
  );
});

export default SVG;
